import React from 'react';

/* atoms */
import { Button } from 'js/components/atoms';

export default function ConversionFlowSubmit({
    flow,
    handleClose = () => { },
    theme = 'primary',
    title = flow?.form?.buttonLabel,
    className = 'btn-block-sm',
    attributes = {
        type: 'submit',
    },
    buttonInPageColor,
    buttonInPageClasses,
    ...passProps
}) {
    const activeStep = flow?.steps.find((step) => step.active);

    return (
        <Button
            className={activeStep.position === 1 && buttonInPageClasses ? buttonInPageClasses : className}
            theme={activeStep.position === 1 && buttonInPageColor ? buttonInPageColor : theme}
            text={title}
            attributes={attributes}
            showIcon={false}
            {...passProps}
            onClick={(e) => {
                if (activeStep?.last) {
                    e.preventDefault();
                    handleClose();
                }
            }}
        />
    );
}
